import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 py-3 flex items-center justify-between">
        <Link
          to="/"
          className="text-xl md:text-2xl font-bold whitespace-nowrap cursor-pointer"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          <span className="text-foreground-950">韩漫</span>
          <span className="text-accent-500">屋</span>
        </Link>

        <div className="hidden md:flex items-center gap-1 overflow-x-auto">
          {categories.filter(c => c.slug !== 'all').map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm transition-colors cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? 'bg-accent-500 text-background-50'
                  : 'text-foreground-700 hover:text-accent-500'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className={`whitespace-nowrap text-sm cursor-pointer transition-colors ${
              location.pathname === '/about'
                ? 'text-accent-500 font-medium'
                : 'text-foreground-600 hover:text-foreground-950'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer text-foreground-950"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          <div className="flex flex-wrap gap-2 mb-3">
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm transition-colors cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-accent-100 hover:text-accent-700'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
          <Link
            to="/about"
            className={`block px-3 py-1.5 text-sm cursor-pointer ${
              location.pathname === '/about'
                ? 'text-accent-500 font-medium'
                : 'text-foreground-600 hover:text-foreground-950'
            }`}
          >
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}